<ng-container *ngIf="payeeOverride?.address1 &&
  (!isInternational || isClientProcessing)">
  <yc-fa icon="star"
    [light]="true"
    class="me-2 text-link">
  </yc-fa>
  <span>
    <yc-i18n
      key="MANAGE:textAlternateAddressRequest"
      defaultValue="Alternate address request">
    </yc-i18n>: 
    <span *ngIf="showName">
      {{ payeeOverride.name }}
    </span> 
    <span [innerHTML]="{
      address1: payeeOverride.address1,
      address2: payeeOverride.address2,
      city: payeeOverride.city,
      postalCode: payeeOverride.postalCode,
      countryCode: payeeOverride.country,
      stateProvRegCode: payeeOverride.state
    } | address: true">
    </span>
  </span>
</ng-container>